"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Display: function() {
        return _index.Display;
    },
    displayClassNames: function() {
        return _index.displayClassNames;
    }
});
const _index = require("./components/presets/Display/index");
